export default __webpack_public_path__ + "static/media/video.1b896c97.svg";